import { buildApiRequest } from 'utils/api';
import { BASE_URL } from 'utils/urls';

const urlHelper = {
  getTransactions: (params: any) => buildApiRequest('GET', `${BASE_URL}/odin/v3/transactions`, params),
  patchTransaction: (params: any) => buildApiRequest('PATCH', `${BASE_URL}/odin/v3/transactions`, params),
  postBatch: (params: any) => buildApiRequest('POST', `${BASE_URL}/odin/v3/transactions/batch`, params),
  submitOtp: (params: any) =>
    buildApiRequest('POST', `${BASE_URL}/odin/v3/transactions/batch/${params.batchId}/pay`, params),
  resendOtp: (params: any) =>
    buildApiRequest('POST', `${BASE_URL}/odin/v3/transactions/batch/${params.batchId}/resend-otp`, params),
};

export default urlHelper;
